import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useQuery from 'hooks/useQuery'
import validateFullName from 'schemas/fullName'
import { IndentifiedTranslatorContext } from 'context/IdentifiedTranslatorContext'
import IdentifyForm from './IdentifyForm'

function IdentifyFormContainer() {
  const navigate = useNavigate()

  const { setTranslator } = useContext(IndentifiedTranslatorContext)

  const [errorStatus, setErrorStatus] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { makeRequest } = useQuery({
    defaultEndpoint: '/translators',
    defaultMethod: 'patch',
    isControlled: true,
    toastOptions: {
      showFeedbackMessage: false,
    },
  })

  const initialValues = {
    firstName: '',
    lastName: '',
    speciality: '',
  }

  const onSubmitForm = async (values) => {
    setIsSubmitting(true)
    const response = await makeRequest({ body: values })
    if (response.error) {
      setErrorStatus(response.code)
      setErrorMessage(response.message)
      setIsSubmitting(false)
      return
    }
    setTranslator({
      firstName: values.firstName,
      lastName: values.lastName,
      speciality: values.speciality,
    })
    navigate('/translators')
  }

  return (
    <IdentifyForm
      initialValues={initialValues}
      validationSchema={validateFullName}
      onSubmitForm={onSubmitForm}
      error={errorStatus}
      errorMessage={errorMessage}
      isSubmitting={isSubmitting}
    />
  )
}

export default IdentifyFormContainer
